import { useRef } from 'react';
import { useTranslation } from 'next-i18next';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import HeroSection from './sections/HeroSection';
import BeddingSection from './sections/BeddingSection';
import SeoSection from './sections/SeoSection';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
import TipsSection from './sections/TipsSection';
import DiscoveriesSection from './sections/DiscoveriesSection';
import ScentsSection from './sections/ScentsSection';
import BathSection from './sections/BathSection';
import MobileHomePage from './sections/MobileHomePage';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const { t: tHero } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      {/* The page's single h1 (SEO). It sits outside the desktop and mobile layouts, which are
          each hidden per breakpoint, so it stays in the accessibility tree at every width. */}
      <h1 className="sr-only">{tHero('title')}</h1>
      <HeroSection promotion={promotion} />
      <BeddingSection />
      <TipsSection />
      <DiscoveriesSection />
      <ScentsSection />
      <BathSection />
      <SeoSection />
      <MobileHomePage />
    </div>
  );
};

export default Home;
